import { IconCheck, IconCheckCircleActivity, IconEmptyCircleActivity, IconReattemptCircleActivity, IconRedWarning, IconSkipNext } from '@punchcard/core/icons';
import { useTranslation } from 'react-i18next';
import { isStudentApp } from './utils';
import { useMemo } from 'react';

//Lesson status mapping is consistent across all apps
export const useStatusCodeMappingLesson = (): statusCodeMappingLesson => {
	const { t } = useTranslation();
	return useMemo(() => {
		return {
			'Open': { className: 'text-gray-800', status: t('lesson_status.open') },
			'InProgress': { className: 'text-gray-800', status: t('lesson_status.in_progress') },
			'ReAttempt': { icon: IconRedWarning, activeIconClassName: 'text-danger-100', className: 'text-gray-800', status: t('lesson_status.reattempt') },
			'ReadyForReview': { icon: IconRedWarning, activeIconClassName: 'text-danger-100', className: 'text-gray-800', status: t('lesson_status.reattempt') },
			'Completed': { icon: IconCheck, activeIconClassName: 'text-success-100', className: 'text-success-600', status: t('lesson_status.completed') },
		};
	}, [t]);
};

export const useActivityStatusMapping = (): statusCodeMappingActivity => {
	const { t } = useTranslation();
	return useMemo(() => {
		if (isStudentApp) {
			return {
				Open: {
					icon: IconEmptyCircleActivity,
					className: 'text-dark',
					status: t('activity_status.open'),
					clickable: true,
					activeStatus: t('activity_status.current'),
					activeClassName: 'text-primary-700',
				},
				InProgress: {
					icon: IconEmptyCircleActivity,
					className: 'text-dark',
					status: t('activity_status.in_progress'),
					clickable: true,
					activeStatus: t('activity_status.current'),
					activeClassName: 'text-primary-700',
				},
				ReAttempt: {
					icon: IconRedWarning,
					className: 'text-danger-600',
					status: t('activity_status.reattempt'),
					clickable: true,
					activeStatus: t('activity_status.current'),
					activeClassName: 'text-primary-700',
				},
				ReadyForReview: {
					icon: IconCheckCircleActivity,
					className: 'text-gray-800',
					status: t('activity_status.ready_for_review'),
					clickable: false,
					activeStatus: t('activity_status.current'),
					activeClassName: 'text-primary-700',
				},
				Completed: {
					icon: IconCheckCircleActivity,
					className: 'text-success-600',
					status: t('activity_status.completed'),
					clickable: false,
					activeStatus: t('activity_status.current'),
					activeClassName: 'text-primary-700',
				},
				Skipped: {
					icon: IconSkipNext,
					className: 'text-gray-800',
					status: t('activity_status.skipped'),
					clickable: false,
					activeStatus: t('activity_status.current'),
					activeClassName: 'text-primary-700',
				},
			};
		}
		else {
			return {
				Open: {
					icon: IconEmptyCircleActivity,
					className: 'text-gray-600',
					status: t('activity_status.open'),
					clickable: false,
					activeStatus: t('activity_status.current'),
					activeClassName: 'text-gray-600',
				},
				InProgress: {
					icon: IconEmptyCircleActivity,
					className: 'text-dark',
					status: t('activity_status.in_progress'),
					clickable: false,
					activeStatus: t('activity_status.current'),
					activeClassName: 'text-dark',
				},
				ReAttempt: {
					icon: IconReattemptCircleActivity,
					className: 'text-gray-700',
					status: t('activity_status.reattempt'),
					clickable: false,
					activeStatus: t('activity_status.current'),
					activeClassName: 'text-gray-800',
				},
				ReadyForReview: {
					icon: IconRedWarning,
					className: 'text-danger-600',
					status: t('activity_status.ready_for_review'),
					clickable: true,
					activeStatus: t('activity_status.current'),
					activeClassName: 'text-danger-600',
				},
				Completed: {
					icon: IconCheckCircleActivity,
					className: 'text-success-600',
					status: t('activity_status.completed'),
					clickable: false,
					activeStatus: t('activity_status.current'),
					activeClassName: 'text-success-600',
				},
				Skipped: {
					icon: IconSkipNext,
					className: 'text-gray-800',
					status: t('activity_status.skipped'),
					clickable: false,
					activeStatus: t('activity_status.current'),
					activeClassName: 'text-gray-800',
				},
			};
		}
	}, [t]);
};